(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('landing-collection-list')) {
    class LandingCollectionList extends HTMLElement {
      constructor() {
        super();
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.preventNativeDrag = this.preventNativeDrag.bind(this);
      }

      connectedCallback() {
        this.scroller = this.querySelector('.landing-collection-list__list');

        if (!this.scroller) return;

        this.scroller.addEventListener('pointerdown', this.handlePointerDown);
        this.scroller.addEventListener('dragstart', this.preventNativeDrag);
        this.addEventListener('click', this.handleClick, true);
      }

      disconnectedCallback() {
        if (!this.scroller) return;

        this.scroller.removeEventListener('pointerdown', this.handlePointerDown);
        this.scroller.removeEventListener('dragstart', this.preventNativeDrag);
        this.removeEventListener('click', this.handleClick, true);
      }

      preventNativeDrag(event) {
        event.preventDefault();
      }

      handleClick(event) {
        if (!this.suppressClick) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.suppressClick = false;
      }

      handlePointerDown(event) {
        if (!this.scroller || event.button !== 0 || this.scroller.scrollWidth <= this.scroller.clientWidth) return;

        const startX = event.clientX;
        const startY = event.clientY;
        const startScrollLeft = this.scroller.scrollLeft;
        const originalScrollSnapType = this.scroller.style.scrollSnapType;
        const controller = new AbortController();
        const { signal } = controller;
        let isDragging = false;

        const finishDrag = () => {
          controller.abort();

          if (isDragging) {
            this.suppressClick = true;
            window.setTimeout(() => {
              this.suppressClick = false;
            }, 150);
          }

          this.removeAttribute('dragging');
          this.scroller.style.scrollSnapType = originalScrollSnapType;
        };

        const handlePointerMove = (moveEvent) => {
          const deltaX = moveEvent.clientX - startX;
          const deltaY = moveEvent.clientY - startY;

          if (!isDragging) {
            if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

            if (Math.abs(deltaY) > Math.abs(deltaX)) {
              finishDrag();
              return;
            }

            isDragging = true;
            this.setAttribute('dragging', '');
            this.scroller.style.scrollSnapType = 'none';
          }

          moveEvent.preventDefault();
          this.scroller.scrollLeft = startScrollLeft - deltaX;
        };

        document.addEventListener('pointermove', handlePointerMove, { signal });
        document.addEventListener('pointerup', finishDrag, { signal });
        document.addEventListener('pointercancel', finishDrag, { signal });
      }
    }

    customElements.define('landing-collection-list', LandingCollectionList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
